function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 106,
  r: 79,
  fill: "#fdffa0",
  transform: "translate(-27.544 -43.747) scale(1.62025)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M46.4 24.6c-.7-.1-1.3-.1-2-.1-4.9 0-9.7 2-14 5.8-2 1.8-3.9 4-5.6 6.4-.3-9.3-.8-19.2-1.8-29.3H10.5c2.7 28.4 2.4 53.2 1.9 75v.1h12.5c.4-21.8 5.8-35.8 13.9-43 2.2-1.9 4.3-2.8 6.2-2.6 9.9 1.1 8.3 31.9 7.6 45.6h12.5c.5-10.1 1.1-22.4-.3-33-2-15.5-8.3-23.8-18.4-24.9z",
  fill: "url(#prefix___Linear1)",
  fillRule: "nonzero",
  transform: "translate(46.149 31.39) scale(2.14926)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix___Linear1",
  x1: 0,
  y1: 0,
  x2: 1,
  y2: 0,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "rotate(-90 61.53 23.38) scale(62.8837)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#0000b4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#0000b4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#000050"
})));

function SvgHoprIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoprIcon);
export default __webpack_public_path__ + "static/media/hopr_icon.9999864c.svg";
export { ForwardRef as ReactComponent };